<script>
import { Bar } from "vue-chartjs";

export default {
  props: {
    labelsChart: Array,
    data: Array,
    datasetsLabel: String,
    color: String,
    colorHover: String,
  },

  extends: Bar,
  mounted() {
    this.renderChart(
      {
        labels: this.labelsChart,
        datasets: [
          {
            barPercentage: 0.4,
            label: this.datasetsLabel,
            backgroundColor: this.color,
            borderColor: this.color,
            borderWidth: 1,
            hoverBackgroundColor: this.colorHover,
            hoverBorderColor: this.colorHover,
            data: this.data,
          },
        ],
      },
      {
        tooltips: {
          enabled: true,
          callbacks: {
            label: function (context) {
              return context.yLabel.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              });
            },
          },
        },

        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                beginAtZero: true,
              },
            },
          ],
        },
      }
    );
  },
};
</script>